import '../../Styles/Card.css'

export default function BackOfCard()  {
    return(
        <div className="BackOfCard" style={{zIndex:2,backgroundColor:"#4477ee"}}>
            <div className="CardFace" style={{zIndex:1}}>
            </div>
        </div>
    )
}